import { Card, CardContent } from "@/components/ui/card";

const AboutTeamComponent = () => {
  return (
    <section className="py-12 px-4 custom-bg-color-01 custom-color-03">
      <div className="max-w-6xl mx-auto">
        <h3 className="text-3xl font-bold text-center mb-6">
          Sobre os Preletores
        </h3>
        <p className="text-center mb-12 text-lg max-w-4xl mx-auto">
          Uma equipe experiente, comprometida com a suficiência das Escrituras e
          a prática do aconselhamento bíblico
        </p>

        {/* Fotos dos Preleitores */}
        <div className="mb-12"></div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {[
            {
              name: "Rev. Marcelo Tavares",
              description:
                "Pastor na Igreja Presbiteriana Central de Contagem. Professor no Seminário Presbiteriano RDNE de Belo Horizonte e na Faculdade Internacional de Teologia Reformada.",
            },
            {
              name: "Rev. Enoch Júnior",
              description:
                "Pastor na Nona Igreja Presbiteriana de Belo Horizonte. Bacharel em Teologia pelo Seminário Presbiteriano RDNE, mestrando em Aconselhamento Bíblico.",
            },
            {
              name: "Cons. Débora Barroso",
              description:
                "Professora e conselheira bíblica na Nona Igreja Presbiteriana de Belo Horizonte. Graduada em Letras pela UFMG, especialista em Aconselhamento Bíblico.",
            },
            {
              name: "Dr. César Miranda dos Santos",
              description:
                "Presbítero há 25 anos. Médico (UFMG). Mestre em Teologia/Estudos Cristãos. Diretor da International Reformed Theological College - FITRef. Autor dos livros: Doença a Luz da Bíblia e A Enfermidade na Vida Cristã.",
            },
            {
              name: "Sem. José Neto",
              description:
                "Evangelista na Nona Igreja Presbiteriana de Belo Horizonte. Teologando pelo Seminário Presbiteriano RDNE, bacharel em Psicologia.",
            },
            {
              name: "Rev. Hugo Cordeiro",
              description:
                "Pastor na Nona Igreja Presbiteriana de Belo Horizonte. Bacharel em Teologia pelo Seminário Presbiteriano RDNE.",
            },
            {
              name: "Taís Boaventura",
              description:
                "Psicóloga graduada pela PUC Minas, conselheira bíblica na Nona Igreja Presbiteriana de BH e líder de Pequeno Grupo.",
            },
            {
              name: "Talita M. Cordeiro",
              description:
                "Mãe, professora e especialista no tema de telas e vícios digitais.",
            },
          ].map((speaker, index) => (
            <Card
              key={index}
              className="hover:shadow-lg transition-shadow custom-bg-color-02 custom-border-color-05"
            >
              <CardContent className="p-6">
                <h4 className="font-semibold text-lg mb-3 custom-color-05">
                  {speaker.name}
                </h4>
                <p className="text-sm leading-relaxed custom-color-01">
                  {speaker.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
export default AboutTeamComponent;
